// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1_3Du","noInteraction":"EventWrapper_noInteraction__2BcEs","pointerPassthrough":"EventWrapper_pointerPassthrough__2mxoi"};